import $ from 'jquery';
import ScrollMagic from 'ScrollMagic';


export default () => {

    if ($(window).width() >= 992) {
        if ($('.lista-prodotti').length > 0) {

            var height = $('.lista-prodotti').outerHeight();
            console.log('height: ' + height);

            var x = $(".lista-prodotti__scroll-column__0").height() * 15 / 100;
            var negative_rem = 20 * 16;
            if ($('.lista-prodotti').attr('class').indexOf('custom-margin-bottom') !== -1) {
                negative_rem = 0;
            }

            var controller2 = new ScrollMagic.Controller({
                globalSceneOptions: {
                    triggerElement: ".lista-prodotti",
                    duration: (height - x - negative_rem) + 'px',
                    triggerHook: 0.5
                }
            });

            $('.trigger-element').css('height', (height - x - negative_rem) + 'px');

            new ScrollMagic.Scene()
                .setTween(".lista-prodotti__scroll-column__0", { y: "-15%", ease: Linear.easeNone })
                .on("progress", (e) => {
                    var percent_white_space = x * e.progress.toFixed(3);
                    $('.trigger-element').css('height', (height - percent_white_space - negative_rem) + 'px');
                })
                //.addIndicators()
                .addTo(controller2);

            new ScrollMagic.Scene()
                .setTween(".lista-prodotti__scroll-column__1", { y: "-30%", ease: Linear.easeNone })
                //.addIndicators()
                .addTo(controller2);

            new ScrollMagic.Scene()
                .setTween(".lista-prodotti__scroll-column__2", { y: "-15%", ease: Linear.easeNone })
                //.addIndicators()
                .addTo(controller2);
        }
    }
};



// WEBPACK FOOTER //
// ./scripts/libs/column-scroll.js